module.exports = __webpack_public_path__ + "static/media/template7-carousel.8a38b9ba.png";